import { createSlice } from "@reduxjs/toolkit";

const viewTypeInitialState = {
  currentViewType: "GRID_VIEW",
};

export const viewTypeReducer = createSlice({
  name: "viewType",
  initialState: viewTypeInitialState,
  reducers: {
    setCurrentView: (state, action) => {
      state.currentViewType = action.payload;
    },
  },
});

export const { setCurrentView } = viewTypeReducer.actions;

export default viewTypeReducer.reducer;
